// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","Link":"medkit__Link__Link","LinkStandalone":"medkit__Link__LinkStandalone","LinkActive":"medkit__Link__LinkActive"};